import createHeaders from "@utils/createHeaders";

export const headers = createHeaders([
  { text: 'No', value: 'number_index', width: '10' },
  { text: 'Wilayah', value: 'kode_wilayah' },
  { text: 'Sandi Cabang', value: 'sandi_cabang' },
  { text: 'Branch Code BC / KO', value: 'branch_code_bcko' },
  { text: 'Kode Cabang', value: 'kode_cabang' },
  { text: 'Status Outlet', value: 'outlet_status' },
  { text: 'Nama Outlet', value: 'outlet_name' },
  { text: 'Create Date', value: 'created_at' },
  { text: 'Last Update', value: 'updated_at' },
  { text: 'Action', value: 'action', width: '10' },
]);

export const search = {
  kode_wilayah: '',
  sandi_cabang: '',
  branch_code_bcko: '',
  kode_cabang: '',
  outlet_status: '',
  outlet_name: '',
  created_at: '',
  updated_at: '',
};
